import { Card } from '@ipfabric/ui-components/Card/Card';
import type { UseQueryResult } from '@tanstack/react-query';

type GuardedEntityCount = { key: string; label: string; count: number };

type GuardedEntityCountsProps = {
  preview: UseQueryResult<GuardedEntityCount[]>;
  snapshotSelected: boolean;
};

export const GuardedEntityCounts = ({
  preview,
  snapshotSelected,
}: GuardedEntityCountsProps) => {
  const renderBody = () => {
    if (!snapshotSelected) {
      return (
        <span className='text-element-secondary'>
          Select a snapshot to see impact.
        </span>
      );
    }
    if (preview.fetchStatus === 'idle' && !preview.data) {
      return (
        <span className='text-element-secondary'>
          Complete the condition to see matching entities.
        </span>
      );
    }
    if (preview.isError) {
      return (
        <span className='text-status-error'>Could not count entities.</span>
      );
    }
    return (
      <div className='grid grid-cols-2 gap-xs'>
        {(preview.data ?? []).map((entry) => (
          <div
            key={entry.key}
            className='flex flex-col rounded border border-default p-xs'
            data-testid={`guarded-count-${entry.key}`}
          >
            <span className='text-level-3 font-semibold'>
              {preview.isFetching ? '…' : entry.count}
            </span>
            <span className='text-sm capitalize text-element-secondary'>
              {entry.label}
            </span>
          </div>
        ))}
      </div>
    );
  };

  return (
    <Card className='flex flex-col gap-xs p-sm'>
      <h4 className='m-0 font-semibold'>Guarded entities in active snapshot</h4>
      {renderBody()}
    </Card>
  );
};
